import { Link as CapraLink } from '@capra/core';
import NextLink from 'next/link';
import styled from 'styled-components';

export const DropdownSection = styled.section`
  height: 32px;
  padding: 8px 12px;
  display: flex;
`;

export const DropdownDivider = styled.section`
  background: rgba(0, 0, 0, 0.06);
  height: 1px;
`;

export const BoldedDropdownSection = styled.section`
  padding: 4px 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

export const DropdownWrap = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px; /* match what Stream has */
  gap: 4px;
  padding: 4px 0;
  width: 367px;
`;

export const DropdownLink = styled(CapraLink).attrs({ as: NextLink })`
  display: flex;
  align-items: center;
  color: var(--text-color);
  gap: 8px;

  &:hover,
  &:visited,
  &:focus {
    color: var(--text-color) !important;
  }
`;
